'use strict';

export default class SettingsController {
  user = {
    email: '',
    phone: '',
    newPassword: '',
    confirmPassword: ''
  };
  errors = {
    other: undefined
  };
  message = '';
  submitted = false;
  phoneBackup = '';

  /*@ngInject*/
  constructor(Auth, $stateParams, $state, $http, $timeout, $scope, Signup, $uibModal) {
    this.Auth = Auth;
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.$http = $http;
    this.$timeout = $timeout;
    this.$scope = $scope;
    this.Signup = Signup
    this.$uibModal = $uibModal;
  }

  /*To check initially if the page is valid or not*/
  $onInit() {
    console.log(this.$stateParams.id);
    //This means that this link points to forgot password flow
    if (this.$stateParams.id != undefined) {
      this.validatePage();
    }
    //This link points to the change password flow
    else {
      /*Set the email as the read only field*/
      this.Auth.getCurrentUser()
        .then((user) => {
          this.user.email = user.email;
          if (user.phone) {
            this.user.phone = Number(user.phone);
            this.phoneBackup = this.user.phone
          }
        })
        .catch((error) => {
          //Set to the login state as the user wont be defined
          this.$state.go('login');
        })
    }
  }

  validatePage = () => {
    console.log('Validating the url');
    this.$http.get('/api/users/' + this.$stateParams.id + '/password/')
      .then(response => {
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error.data);
        this.$state.go('signupError');
      })
  }



  /*To check after the user clicks the change password button*/
  changePassword(form) {
    let params;
    this.submitted = true;

    if (form.$valid) {
      /*If the unique id is null ,means that the state is editAccount then set the parameters to email*/
      if (this.$stateParams.id == undefined) {
        params = 'email:' + form.email.$viewValue;
      }
      else {
        params = 'uuid:' + this.$stateParams.id;
      }
      if (this.user.phone && this.user.phone !== this.phoneBackup) {
        if (this.user.newPassword) {
          if (this.user.newPassword !== this.user.confirmPassword) {
            this.errors.confirmPassword = 'Password does not matched.';
          }
          else
            this.sendPhoneCode()
        }
        else
          this.sendPhoneCode()
      }
      else {
        if (!this.user.newPassword) {
          this.errors.newPassword = 'Please enter password.';
        }
        else if (this.user.newPassword !== this.user.confirmPassword) {
          this.errors.confirmPassword = 'Password does not matched.';
        }
        else {
          this.Auth.changePassword(params, this.user.newPassword, this.user.confirmPassword)
            .then(() => {
              this.errors.confirmPassword = 'Password successfully changed.';

              this.$timeout(() => {
                this.$state.go('procedureStatus');
              }, 1000);

            })
            .catch(error => {
              console.log(error);
              if (error.data[0] == 'Expired Link') {
                this.$state.go('signupError');
              }
              else if (error.data[0] == 'Incorrect Password') {
                this.errors.oldPassword = 'Incorrect Password';
              }
              else {
                this.errors.confirmPassword = error.data[0];
              }
            });
        }
      }
    }
  }

  // To send phone code
  sendPhoneCode() {
    return this.Auth.sendPhoneCode({
      email: this.user.email,
      phone: this.user.phone
    })
      .then((response) => {
        // console.log('sendPhoneCode-------', response)
        this.user.phoneVerificationCode = response.phoneVerificationCode
        this.openModal({id: response._id})
      })
      .catch(err => {
        err = err.data;
        this.errors.confirmPassword = err[0];
        console.log(this.errors);
      });
  }

  editAccountInfo() {
    let body = {};
    body.phone = this.user.phone
    body.isVerfiedPhone = this.user.isVerfiedPhone
    if (this.user.newPassword) {
      body.newPassword = this.user.newPassword
    }
    // console.log('current body -> ', body)
    // console.log('current email -> ', this.user.email)
    return this.Auth.editAccountInfo(this.user.email, body)
      .then((response) => {
        // console.log('Edited User -> ', response)
        if (response.phone)
          this.Auth.updateCurrentUserSync(response.phone)
        this.$timeout(() => {
          this.$state.go('procedureStatus');
        }, 1000);
      })
      .catch(err => {
        console.log('err', err)
        err = err.data;
        this.errors.confirmPassword = err[0];
        console.log(this.errors);
      });
  }
  
  openModal = (data) => {
    let template = require('../../../components/user-modification-modal/phone-verification-model.html')

    var modalInstance = this.$uibModal.open({
      //      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      template: template,
      controller: 'UserModificationModalController',
      controllerAs: 'vm',
      //      size: size,
      //      appendTo: parentElem,
      resolve: {
        editUser: () => {
          return data
        }
      }
    });

    modalInstance.result.then(() => {
      console.log('Verify successful.');
      this.user.isVerfiedPhone = true
      this.editAccountInfo()
    }, function () {
      console.log('Modify User Modal dismissed.');
    })
  }
}



// WEBPACK FOOTER //
// ./client/app/account/settings/settings.controller.js